Paraphrase the following statement: {{statement}}
